// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_o4K","cls2":"ResearchInterestsCard-cls2_x9t ResearchInterestsCard-cls1_o4K"};